<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Gerenciamento de Regras de Permanência
      </p>
    </div>
    <div class="col-md-2 q-mt-lg">
      <q-btn
        @click="rightDrawerModalOpen = true"
        icon="done"
        no-caps
        style="background-color: #21324a; border-radius: 8px; color: white"
        label="Criar Regra"
      />
    </div>
    <div>
      <div class="row text-brand-5 text-weight-bold q-mt-md">
        <div class="col-md-2">
          Unidade

          <lista-unidades-select
            class="input-new-design"
            v-model="filtros.unidade"
          ></lista-unidades-select>
        </div>
        <div class="col-md-3 q-ml-sm">
          Catálogo

          <q-select
            v-model="filtros.catalogo"
            behavior="menu"
            option-label="nome"
            class="input-new-design"
            option-value="catalogoUuid"
            map-options
            emit-value
            :options="catalogoOptions"
            dense
            outlined
            @filter="filterCatalogo"
            use-input
          />
        </div>
        <div class="col-md-2 q-ml-sm">
          Tipo de Regra
          <q-select
            v-model="filtros.agrupadorTipo"
            behavior="menu"
            option-label="nome"
            class="input-new-design"
            :options="agrupadorTipoOptions"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 q-ml-sm">
          Nome do Campo

          <q-select
            v-model="filtros.agrupadorNome"
            behavior="menu"
            :disable="filtros.agrupadorTipo == ''"
            class="input-new-design"
            option-label="nome"
            :options="agrupadorNomeOptions"
            dense
            outlined
          />
        </div>

        <div class="col-md-1 q-ml-sm q-mt-lg">
          <q-btn
            @click="getDados()"
            icon="filter_alt"
            no-caps
            :disable="filtros.catalogo == ''"
            style="background-color: #7ab9e0; border-radius: 8px; color: white"
            label="Filtrar"
          />
        </div>
      </div>

      <q-table
        flat
        table-header-class="bg-accent text-width-bold q-mt-md"
        :rows="rows"
        :loading="disable"
        dense
        color="primary"
        :columns="columns"
        v-model:pagination="pagination"
        class="tabela-tamanho-fixo q-mt-md"
        row-key="name"
        hide-pagination
        @request="handleRequest"
      >
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
          >
            Regras Criadas</span
          >
        </template>
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template #body-cell-detalhe="props">
          <q-td>
            <q-btn
              flat
              no-caps
              color="blue"
              icon="sym_o_add_circle"
              round
              @click="(dialog = true), (agrupador = { ...props.row })"
            />
          </q-td>
        </template>
        <template #body-cell-remover="props">
          <q-td>
            <q-btn
              flat
              no-caps
              color="red"
              icon="sym_o_delete"
              round
              @click="(confirmacao = true), (saveId = props.row)"
            />
          </q-td>
        </template>
      </q-table>
      <div v-if="rows.length != 0" class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
      <Transition name="slide-fade">
        <q-card v-if="rightDrawerModalOpen" class="drawer-modal">
          <div class="row q-pa-md text-weight-bold">
            <div class="row col-12 items-center justify-between">
              <div class="row">
                <q-icon
                  style="cursor: pointer"
                  name="close"
                  class="q-mr-md"
                  size="22px"
                  @click="rightDrawerModalOpen = false"
                />
                <span style="font-size: 16px">
                  <span>
                    <span>Criar Regra</span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <q-scroll-area class="teste" style="width: 100%; height: 92%">
            <div class="column col-12 no-wrap">
              <div class="q-px-md text-weight-bold">
                <div class="col-md-12 q-mt-xs">
                  Catálogo:

                  <q-select
                    v-model="criacaoDados.catalogo"
                    behavior="menu"
                    option-label="nome"
                    class="input-new-design"
                    option-value="catalogoUuid"
                    map-options
                    emit-value
                    :options="catalogoOptions"
                    dense
                    outlined
                    @filter="filterCatalogo"
                    use-input
                  />
                </div>
                <div class="col-md-12 q-mt-sm">
                  Tipo de Regra:
                  <q-select
                    v-model="criacaoDados.agrupadorTipo"
                    behavior="menu"
                    option-label="nome"
                    class="input-new-design"
                    :options="agrupadorTipoOptions"
                    dense
                    outlined
                  />
                </div>
                <div class="col-md-12 q-mt-sm">
                  Nome do Campo

                  <q-select
                    v-model="criacaoDados.agrupadorNome"
                    behavior="menu"
                    :disable="criacaoDados.catalogo == ''"
                    class="input-new-design"
                    option-label="nome"
                    :options="agrupadorNomeCriacaoOptions"
                    dense
                    outlined
                  />
                </div>
              </div>
              <div class="q-px-md q-mt-md q-pb-md">
                <q-btn
                  style="
                    background-color: #21324a;
                    border-radius: 8px;
                    color: white;
                    font-weight: normal;
                  "
                  label="Criar"
                  no-caps
                  icon="add"
                  :disable="criacaoDados.catalogo == ''"
                  @click="criarRegra"
                />
              </div>
            </div>
          </q-scroll-area>
        </q-card>
      </Transition>
    </div>
    <dialog-confirm-design
      mensagem="Tem certeza que deseja excluir a Regra"
      :exibir="confirmacao"
      @resultado="excluirRegra"
    />

    <q-dialog v-model="dialog">
      <q-card style="width: 700px; max-width: 80vw">
        <q-card-section>
          <div v-if="listaTabela.length > 0" class="text-h6">
            {{
              agrupador.agrupadorTipo == "grupo"
                ? `Agrupador: Grupo - ${listaTabela[0]?.catalogoItem?.catalogoGrupo?.nome}`
                : agrupador.agrupadorTipo == "subgrupo"
                ? `Agrupador: SubGrupo - ${listaTabela[0]?.catalogoItem?.catalogoSubGrupo?.nome}`
                : agrupador.agrupadorTipo == "ativo"
                ? `Agrupador: Ativo - ${listaTabela[0]?.catalogoItem?.nome}`
                : agrupador.agrupadorTipo == "item"
                ? `Agrupador: Item - ${listaTabela[0]?.catalogoItem?.codigo}`
                : agrupador.agrupadorTipo == "catalogo"
                ? `Agrupador: Catálogo - ${listaTabela[0]?.catalogoItem?.catalogo}`
                : ""
            }}
          </div>
          <div v-else class="text-h6">Agrupador:</div>
        </q-card-section>
        <q-separator />
        <q-card-section class="scroll col-12">
          <q-table
            class="col-12"
            flat
            table-header-class="bg-accent text-width-bold q-mt-md"
            :columns="columnsAtivo"
            :rows="listaTabela"
            v-model:pagination="paginationListaTabela"
            :loading="loadindListaTabela"
            dense
            color="primary"
            hide-bottom
          >
            <template v-slot:header="props">
              <q-tr :props="props">
                <q-th
                  class="text-weight-bolder"
                  v-for="col in props.cols"
                  :key="col.name"
                  :props="props"
                >
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>
            <template v-slot:body-cell-codigo="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row.catalogoItem?.codigo ?? props.row.codigo }}
              </q-td>
            </template>
            <template v-slot:body-cell-descricao="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row.catalogoItem?.nome ?? props.row.codigo }}
              </q-td>
            </template>
            <template v-slot:body-cell-patrimonio="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{ props.row?.patrimonio }}
              </q-td>
            </template>
          </q-table>
          <div
            v-if="listaTabela.length != 0"
            class="row justify-center q-mt-md"
          >
            <q-pagination
              :disable="disableListaTabela"
              v-model="paginationListaTabela.page"
              color="brand-5"
              active-color="secondary"
              active-text-color="white"
              :max="pagesNumberListaTabela"
              :max-pages="5"
              :boundary-numbers="false"
              :direction-links="true"
              size="sm"
            />
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "tipo",
    label: "Agrupador Tipo",
    field: (row) => row.agrupadorTipo,
    align: "left",
  },
  {
    name: "agrupador",
    label: "Nome Agrupador",
    field: (row) => row.agrupadorNome,
    align: "left",
  },
  {
    name: "status",
    label: "Nome Catalogo",
    field: (row) => row.catalogoNome,
    align: "left",
  },
  {
    name: "nome_documento",
    label: "Data de Criação",
    field: (row) => row.criadoEm.split(" ")[0].split("-").reverse().join("/"),
    align: "left",
  },

  {
    name: "detalhe",
    label: "Detalhes",
    align: "left",
  },

  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

const columnsAtivo = [
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },

  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },

  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, computed, watch } from "vue";

import DialogConfirmDesign from "../../../components/DialogConfirmDesign.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: { ListaUnidadesSelect, DialogConfirmDesign },
  setup() {
    const store = useStore();

    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(false);
    const rightDrawerModalOpen = ref(false);
    const agrupadorNomeOptions = ref([]);
    const agrupadorNomeCriacaoOptions = ref([]);
    const filtros = ref({
      agrupadorTipo: "",
      agrupadorNome: "",

      catalogo: "",
      unidade: "",
    });
    const confirmacao = ref(false);
    const saveId = ref(null);
    const criacaoDados = ref({
      agrupadorTipo: "",
      agrupadorNome: "",
      catalogo: "",
      unidade: "",
    });
    const time = ref(null);
    const catalogoOptions = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const paginationListaTabela = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const dialog = ref(false);
    const agrupador = ref({});
    const listaTabela = ref([]);
    const loadindListaTabela = ref(false);
    const disableListaTabela = ref(false);

    const getDados = async (page = 0, rowsPerPage = 15) => {
      if (filtros.value.catalogo?.catalogoUuid == undefined) {
        rows.value = [];
        return;
      }
      disable.value = true;
      try {
        let response = await store.dispatch(
          "ferramentaria/listarRegrasCriadas",
          {
            unidadeId: store.state.org.unidadeData.id,
            catalogoUuid: filtros.value.catalogo?.catalogoUuid,
            page: page,
            per_page: rowsPerPage,
          }
        );

        rows.value = response.data.resultado.dados;

        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        pagination.value.rowsNumber = response.data.resultado.total;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getCatalogos = async (val, selecionarCatalogo = false) => {
      try {
        let response = await store.dispatch("ferramentaria/listarCatalogo", {
          nome: val,
          unidadeId: store.state.org.unidadeData.id,
        });

        catalogoOptions.value = response.response.data.resultado.dados;

        if (catalogoOptions.value.length == 0) {
          filtros.value.catalogo = "";
        }

        if (selecionarCatalogo && catalogoOptions.value.length != 0) {
          filtros.value.catalogo = catalogoOptions.value[0];
        }

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar catalogos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(async () => {
      await getCatalogos("", true);
      getDados();
    });

    const criarRegra = async () => {
      try {
        await store.dispatch("ferramentaria/criarRegra", {
          catalogoUuid: criacaoDados.value.catalogo,
          agrupadorTipo: criacaoDados.value.agrupadorTipo,
          agrupadorUuid: criacaoDados.value.agrupadorNome.id,
        });

        getDados(pagination.value.page, pagination.value.rowsPerPage);
        quasar.notify({
          message: "Regra Criada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o criar regra",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getTipo = async () => {
      let response = null;
      try {
        switch (filtros.value.agrupadorTipo) {
          case "catalogo":
            response = await store.dispatch("ferramentaria/listarCatalogo", {
              catalogoUuid: filtros.value.catalogo,
              agrupadorTipo: filtros.value.agrupadorTipo,
              perPage: 100,
            });
            agrupadorNomeOptions.value =
              response.response.data.resultado.dados.map((value) => {
                return { ...value, id: value.catalogoUuid };
              });
            break;
          case "ativo":
            response = await store.dispatch("ferramentaria/listarAtivo", {
              catalogoUuid: filtros.value.catalogo,
              agrupadorTipo: filtros.value.agrupadorTipo,
              perPage: 200,
            });
            agrupadorNomeOptions.value =
              response.response.data.resultado.dados.map((value) => {
                return {
                  ...value,
                  nome: value.catalogoItem.nome,
                  id: value.ativoUuid,
                };
              });

            break;
          case "item catalogo":
            response = await store.dispatch("ferramentaria/listarFerramentas", {
              catalogoUuid: filtros.value.catalogo,

              perPage: 100,
            });
            agrupadorNomeOptions.value = response.listaFerramentas.map(
              (value) => {
                return { ...value, nome: value.descricao, id: value.uuid };
              }
            );
            break;
          case "grupo":
            response = await store.dispatch(
              "ferramentaria/listarGruposCriados",
              {
                catalogoUuid: filtros.value.catalogo,

                perPage: 100,
              }
            );
            agrupadorNomeOptions.value = response.data.resultado.dados.map(
              (value) => {
                return { ...value, id: value.catalogoGrupoUuid };
              }
            );
            break;
          case "subgrupo":
            response = await store.dispatch(
              "ferramentaria/listarSubgrupoGrupo",
              {
                catalogoUuid: filtros.value.catalogo,
                agrupadorTipo: filtros.value.agrupadorTipo,
                perPage: 100,
              }
            );
            agrupadorNomeOptions.value = response.data.resultado.dados.map(
              (value) => {
                return { ...value, id: value.catalogoSubGrupoUuid };
              }
            );
            break;
          default:
        }
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar catalogos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getTipoCriacao = async () => {
      let response = null;
      try {
        switch (criacaoDados.value.agrupadorTipo) {
          case "catalogo":
            response = await store.dispatch("ferramentaria/listarCatalogo", {
              catalogoUuid: criacaoDados.value.catalogo,
              agrupadorTipo: criacaoDados.value.agrupadorTipo,
              perPage: 100,
            });
            agrupadorNomeCriacaoOptions.value =
              response.response.data.resultado.dados.map((value) => {
                return { ...value, id: value.catalogoUuid };
              });
            break;
          case "ativo":
            response = await store.dispatch("ferramentaria/listarAtivo", {
              catalogoUuid: criacaoDados.value.catalogo,
              agrupadorTipo: criacaoDados.value.agrupadorTipo,
              perPage: 200,
            });
            agrupadorNomeCriacaoOptions.value =
              response.response.data.resultado.dados.map((value) => {
                return {
                  ...value,
                  nome: value.catalogoItem.nome,
                  id: value.ativoUuid,
                };
              });

            break;
          case "item catalogo":
            response = await store.dispatch("ferramentaria/listarFerramentas", {
              catalogoUuid: criacaoDados.value.catalogo,

              perPage: 100,
            });
            agrupadorNomeCriacaoOptions.value = response.listaFerramentas.map(
              (value) => {
                return { ...value, nome: value.descricao, id: value.uuid };
              }
            );
            break;
          case "grupo":
            response = await store.dispatch(
              "ferramentaria/listarGruposCriados",
              {
                catalogoUuid: criacaoDados.value.catalogo,

                perPage: 100,
              }
            );
            agrupadorNomeCriacaoOptions.value =
              response.data.resultado.dados.map((value) => {
                return { ...value, id: value.catalogoGrupoUuid };
              });
            break;
          case "subgrupo":
            response = await store.dispatch(
              "ferramentaria/listarSubgrupoGrupo",
              {
                catalogoUuid: criacaoDados.value.catalogo,
                agrupadorTipo: criacaoDados.value.agrupadorTipo,
                perPage: 100,
              }
            );
            agrupadorNomeCriacaoOptions.value =
              response.data.resultado.dados.map((value) => {
                return { ...value, id: value.catalogoSubGrupoUuid };
              });
            break;
          default:
        }
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar catalogos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const excluirRegra = async (resultado) => {
      confirmacao.value = false;
      if (resultado) {
        try {
          await store.dispatch("ferramentaria/excluirRegra", {
            catalogoUuid: saveId.value.catalogoUuid,
            agrupadorTipo: saveId.value.agrupadorTipo,
            agrupadorUuid: saveId.value.agrupadorUuid,
          });

          getDados(pagination.value.page, pagination.value.rowsPerPage);
          quasar.notify({
            message: "Regra excluida com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } catch (error) {
          quasar.notify({
            message: "Erro a o excluir regra",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const listarAtivos = async (page = 1, perPage = 15) => {
      disableListaTabela.value = true;
      loadindListaTabela.value = true;

      try {
        const response = await store.dispatch("ferramentaria/listarAtivo", {
          unidadeId: filtros.value.unidade?.id,
          perPage,
          page,
          uuidGrupo:
            agrupador.value.agrupadorTipo == "grupo"
              ? agrupador.value.agrupadorUuid
              : undefined,
          uuidSubgrupo:
            agrupador.value.agrupadorTipo == "subgrupo"
              ? agrupador.value.agrupadorUuid
              : undefined,
          catalogoItemUuid:
            agrupador.value.agrupadorTipo == "item"
              ? agrupador.value.agrupadorUuid
              : undefined,
          ativoUuid:
            agrupador.value.agrupadorTipo == "ativo"
              ? agrupador.value.agrupadorUuid
              : undefined,
          comAcessorios: "sim",
          comCheckLists: "sim",
          comAtributos: "sim",
        });

        listaTabela.value = response.response.data.resultado.dados;

        paginationListaTabela.value.page =
          response.response.data.resultado.currentPage;
        paginationListaTabela.value.rowsPerPage =
          response.response.data.resultado.perPage;
        paginationListaTabela.value.rowsNumber =
          response.response.data.resultado.total;
        disableListaTabela.value = false;
        loadindListaTabela.value = false;
      } catch (error) {
        console.log(error);
        disableListaTabela.value = false;
        loadindListaTabela.value = false;
      }
    };

    const listarItensCatalogo = async (page = 1, perPage = 15) => {
      disableListaTabela.value = true;
      loadindListaTabela.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarFerramentas",
          {
            perPage,
            page,
            catalogoUuid: agrupador.value.agrupadorUuid,
          }
        );

        listaTabela.value = response.response.data.resultado.dados;

        paginationListaTabela.value.page =
          response.response.data.resultado.currentPage;
        paginationListaTabela.value.rowsPerPage =
          response.response.data.resultado.perPage;
        paginationListaTabela.value.rowsNumber =
          response.response.data.resultado.total;
        disableListaTabela.value = false;
        loadindListaTabela.value = false;
      } catch (error) {
        console.log(error);
        disableListaTabela.value = false;
        loadindListaTabela.value = false;
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => paginationListaTabela.value.page,
      () => {
        listarAtivos(
          paginationListaTabela.value.page,
          paginationListaTabela.value.rowsPerPage
        );
      }
    );

    watch(
      () => filtros.value.agrupadorTipo,
      () => {
        filtros.value.agrupadorNome = "";
        getTipo();
      }
    );

    watch(
      () => criacaoDados.value.agrupadorTipo,
      () => {
        filtros.value.agrupadorNome = "";
        getTipoCriacao();
      }
    );

    watch(
      () => dialog.value,
      () => {
        if (dialog.value) {
          listarAtivos();
          return;
        }

        listaTabela.value = [];
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        filtros.value.unidade = store.state.org.unidadeData;
        getCatalogos("", true);
      }
    );

    watch(
      () => filtros.value.catalogo?.catalogoUuid,
      () => {
        getDados();
      }
    );

    return {
      rows,
      columns,
      getDados,
      handleRequest,
      criarRegra,
      excluirRegra,
      listarAtivos,
      agrupadorTipoOptions: [
        "catalogo",
        "ativo",
        "item catalogo",
        "grupo",
        "subgrupo",
      ],
      rightDrawerModalOpen,
      confirmacao,
      disableListaTabela,
      saveId,
      listarItensCatalogo,
      loadindListaTabela,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,
      pagination,
      disable,
      agrupadorNomeCriacaoOptions,
      criacaoDados,
      agrupadorNomeOptions,
      dialog,
      columnsAtivo,
      listaTabela,
      agrupador,
      paginationListaTabela,
      pagesNumberListaTabela: computed(() =>
        Math.ceil(
          paginationListaTabela.value.rowsNumber /
            paginationListaTabela.value.rowsPerPage
        )
      ),
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      catalogoOptions,
      filterCatalogo(val, update) {
        clearTimeout(time.value);

        time.value = setTimeout(() => {
          getCatalogos(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
    };
  },
};
</script>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>

<style scoped>
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 350px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.teste {
  z-index: 2;
  overflow: hidden;
}
tbody tr td {
  white-space: pre-wrap;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
</style>
